import React from 'react'
import SwoodleLogo from '../../../../Assets/Icons/SwoodleUpdatedLogo.svg'
import LoginHeader from '../../../common/LoginHeader'

const Header = () => {
  return (
    <div className="w-full px-6 py-4 sticky top-0 z-[1000] bg-white">
      <div style={{
        width: "100%",
        maxWidth: "min(1920px, calc(100vw - 2vw))",
        margin: "0 auto"
      }}>
        <LoginHeader />
      </div>
    </div>
  )
}

export default Header;